import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import { FC } from 'react'

import { getTranslate } from '../../localization'
import useStyles from './styles/SitekeysTable.styles'

interface SitekeysTableProps {
  refetch: () => void
}
const SitekeysTableHeaders: FC<SitekeysTableProps> = ({ refetch }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Entity type')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Entity name')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Website')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Sitekey')}</Typography>
      </div>
      <div>
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default SitekeysTableHeaders
